@if (state !== MessageState.WithScreenshot) {
  <cs-header>
    <cs-header-title>{{ LL.sendCoachMessage.title() }}</cs-header-title>
  </cs-header>
}

@if (state === MessageState.WithScreenshot) {
  <cs-screenshot-annotator [imageDataUrl]="screenshotDataUrl" (closeRequested)="onCloseClicked()">
    <div class="form-header">
      <p class="form-title">{{ LL.sendCoachMessage.title() }}</p>
    </div>
    <cs-textarea [(value)]="messageText" [placeholder]="LL.sendCoachMessage.placeholder()" class="compact"></cs-textarea>
    <div class="form-actions">
      <cs-button primary [disabled]="!messageText.trim()" (click)="onSendClicked()">{{ LL.sendCoachMessage.send() }}</cs-button>
    </div>
  </cs-screenshot-annotator>
}

@if (state === MessageState.WriteMessage) {
  <cs-content>
    <cs-card-list>
      <cs-card class="message-form-card">
        <div class="message-form">
          <div class="form-header">
            <p class="form-title">{{ LL.sendCoachMessage.title() }}</p>
          </div>
          <cs-textarea [(value)]="messageText" [placeholder]="LL.sendCoachMessage.placeholder()"></cs-textarea>
          <div class="form-actions">
            <cs-button secondary icon="camera" (click)="onAddScreenshotClicked()">{{ LL.sendCoachMessage.addScreenshot() }}</cs-button>
            <cs-button primary [disabled]="!messageText.trim()" (click)="onSendClicked()">{{ LL.sendCoachMessage.send() }}</cs-button>
          </div>
        </div>
      </cs-card>
    </cs-card-list>
  </cs-content>
}
